/*!
 * © tix02.be 
 * 
 * This script will be loaded in footer
 * Do not append script that could be deferred in header 
 */
 
'use strict';



/*
 * If you want to use a search form, customise it here 
 */
// import searchformInit from './app/searchform';


/*
 * Basic scroll listener & intersection observer  
 */
//import scrollerInit from './app/scroller';


import useContentNav from './app/content-nav';

/*
 * Nav bar utility
 */
//import navbarInit from './app/navbar';


/*
 * Use Barba to not reload any page?
 */
// import barbaInit from './app/barba';


/*
 * Scroll trigger 
 */
//import scrollTriggerInit from './app/scrollTrigger';


/*
 * Magnetic gadgets ?
 */
// import magneticInit from './app/magnetic';


/*
 * use accordion? 
 */
//import accordionInit from './app/accordion';

/*
 * use google maps?
 */
//import googleMapsController from './app/google-maps';



/*
 * use carousel?
 */
import carouselInit from './app/carousel';


import { select } from './@tix02/utility/dom';



// SHARED 

import useSwipers from './@tix02/init/swipers';
//import useSwiperElements from './@tix02/init/swiper-elements';

/*
 * Configure .scrollable (perfect-scrollbar dependent)
 * @need perfect-scrollbar
 */
// import useScrollable from "./@tix02/init/scrollable";
/*
 * Manage anchor links to be smooth
 * @need /polyfill/smoothscroll.min 
 */
import useAnchorLinks from './@tix02/init/anchor-links';

/*
 * has overlay ?
 */
// import useOverlay from './@tix02/init/overlay';

/* 
 * has burger menu ?
 */
//import useBurgerMenu from './@tix02/init/burger-menu';

import usePanel from './@tix02/init/panel';


/*
 * Translated website? 
 * If you want a dropdown language selector, use this 
 */
//import useI18n from './@tix02/init/i18n';
/*
 * @need @tarekraafat/autocomplete.js
 */
//import useSearchBox from './@tix02/init/searchbox';
//import useImprovedForms from './@tix02/init/forms';
//import useTabs from "../tix02/init/tabs";

//import { getElementSize } from './@tix02/utility/dom';
//import { throttle } from './@tix02/utility/utility';



/* 
 * Web components 
 */
import './@tix02/uix/uix-switch'; 
import './@tix02/uix/uix-searchable-select'; 
// import './@tix02/component/web/uix-notification'; 
// import './@tix02/component/web/uix-modal';

import './app/linear-nav';


(function() {
	//searchformInit();
	//scrollerInit();
	// barbaInit();
	//scrollTriggerInit();
	//magneticInit();
	//navbarInit();
	
	/*
	accordionInit('.aside-nav.-accordion', {
		itemSelector: '.menu > .menu-item.has-children',
		itemBodySelector: '.submenu',
		itemHandlerSelector: ':scope > a',
	});
	*/

	//useScrollable();
	useAnchorLinks();
    /*
	useBurgerMenu({
		BUTTON: '.mobile-primary-nav_handler',
		BUTTON_CLOSE: '.mobile-nav-panel-close_handler',
		ACTIVE_CLASSNAME: 'mobile-nav-panel-shown',
	});
    */


    const mobileNavPanelControl = select('#mobile-primary-nav-handler').first;
    if( mobileNavPanelControl ) {
        usePanel(mobileNavPanelControl);
    }

	const contentNav = select('.content-nav').first;
	if( contentNav ) {
		useContentNav(contentNav);
	}
	
	carouselInit();
	/* 
	useI18n({
		SELECTOR: '',
		SELECTOR_TOGGLE: '',
		ACTIVE_CLASSNAME: '',
	});
	*/
	//useImprovedForms();
	useSwipers();
	//useSwiperElements();
})();


/**
 * Create a map
 * @param {string} elementId 
 * @param {Object} options - 
 * @returns {Promise} - map
 */
app.createMap = async function(elementId, options = {}) {
	if(! mapboxgl ) {
		return;
	}
	mapboxgl.accessToken = appConfig.mapbox.apiKey;
	
	const center = options.center ?? appConfig.mapbox.mapDefaultCenter;
	
	const map = new mapboxgl.Map({
		container: elementId, 
		center: [center[1], center[0]], 
		zoom: options.zoom ?? 7, 
		style: `mapbox://styles/mapbox/${appConfig.mapbox.style}`,
	});
	
	return map;
};



app.addMapMarkers = function(map, markers) {
	
	/*
	const _popup = (profile) => {
		const template = document.getElementById(popup);
		const clone = template.content.cloneNode(true);
		clone.querySelector('.popup--title').textContent = profile.title;
		if( profile.logo ) {
			const logo = document.createElement('img');
			logo.src = profile.logo.url;
			logo.setAttribute('alt', profile.logo.alt ?? profile.title);
			clone.querySelector('.popup--logo').appendChild(logo);
		}
		
		clone.querySelector('.popup--body address').textContent = profile.address;
		clone.querySelector('.popup--read-more-btn').setAttribute('href', profile.url);
		
		const serializer = new XMLSerializer();
		const html = serializer.serializeToString(clone);
		return new mapboxgl.Popup().setHTML(html);
	};
	*/
	
	
	markers
		.filter(marker => marker.placeName && marker.latitude && marker.longitude)
		.forEach(marker => {
			const mkr = new mapboxgl.Marker({ color: 'black' })
				.setLngLat([ marker.longitude, marker.latitude ]);
			
			/*
			if( popup ) {
				try {
					marker.setPopup(_popup(profile));
				} catch(err) {}
			}
			*/	
			mkr.addTo(map);
		});
};



const evt = new CustomEvent('pageLoad', { 
	detail:{ document: document }, 
});
document.dispatchEvent(evt);